import { Component, OnInit } from '@angular/core';
import { CartService } from '../../services/cart.service';
import { StatePersistService } from 'src/app/core/services/state-persist.service';
import { GoogleAnalyticsService } from 'src/app/shared/services/google-analytics.service';
import { AlertService } from 'src/app/core/services/alert.service';
import { SharedConsts } from 'src/app/shared/constants';
import { environment } from 'src/environments/environment';


@Component({
    selector: 'back-in-stock',
    templateUrl: './back-in-stock.component.html',
    styleUrls: ['./back-in-stock.component.scss', '../../cart.component.scss'],
    standalone: false
})
export class BackInStockComponent implements OnInit {
  loading = false;
  nextPage = 1;
  productList = []
  totalProductPages = 1;
  totalProductCount = 0;
  noRecord = true;
  page_size = environment.page_size
  imagePath = environment.s3_path + '/' + environment.product_image_folder + '/'
  constructor(private cartService: CartService, private statePersist: StatePersistService,
    private googleAnalyticsService: GoogleAnalyticsService,
    private alertService: AlertService) { }

  ngOnInit(): void {
    this.getBackInStockProducts()
    this.statePersist.watchbackInStockDetail().subscribe(message => {
      this.nextPage = 1;
      this.productList = []
      this.totalProductPages = 1;
      this.totalProductCount = 0;
      this.statePersist.emitmobileListCountDetails('mobile count change')
      this.getBackInStockProducts()
    })
  }

  // Set boolean class on click of add button
  status: boolean = false;
  productListing = [];
  

  toInteger(value) {
    return parseInt(value)
  }
  
  getBackInStockProducts() {
    let formdata;
    formdata = {"page_size" : this.page_size, "page":this.nextPage}
    this.cartService.getBackInStockProducts(formdata)
    .subscribe(
      data => {
        if (data.response) {
          if (data.status == 2212){
            this.alertService.error(data.response)
          }
          const product_list = data.response.back_in_stock;
          this.totalProductCount = data.response.product_count
          this.totalProductPages = data.response.total_pages;
          if (this.totalProductPages < this.nextPage + 1) {
            this.nextPage = null;
          }
          else {
            this.nextPage += 1;
          }
          if (data.response.total_product_count === 0) {
            this.noRecord = true;
            this.productList = [];
            this.nextPage = 1;
            this.totalProductCount = 0;
            this.totalProductPages = 1
          }
          else {
            this.noRecord = false;

          }
          for (let i = 0; i < product_list.length; i++) {
            product_list[i]['qty'] = ''
            product_list[i]['item_id'] = ''
            this.productList.push(product_list[i]);
          }
        }
        this.loading = false;
      }
    );
  }
  onScrollDown() {
    if ((this.nextPage != 1 && this.nextPage !== null) && !this.loading) {
      this.loading = true;
      this.getBackInStockProducts()
    }

  }
  qytChange(product, qyt) {
    for (let i = 0; i < this.productList.length; i++) {
      if (this.productList[i]['product_id'] == product.product_id) {
        this.productList[i]['qty'] = qyt
      }
    }
  }

  addToCart(product, qyt) {
    this.googleAnalyticsService.eventEmitter(SharedConsts.MYCART_BACKINSTOCK_ADDTOCART_EVENT, SharedConsts.GOOGLEANALYTICSS_EVENT_CATEGORY_NAME, SharedConsts.MYCART_BACKINSTOCK_ADDTOCART_EVENT_ACTION, SharedConsts.GOOGLEANALYTICSS_EVENT_LABEL, SharedConsts.GOOGLEANALYTICSS_EVENT_VALUE);
    let bodyData;
    if (product.qty == '') {
      qyt = 1
    }
    bodyData = {
      "cart_item": {
        "sku": product.sku,
        "qty": qyt
      }
    }
    this.cartService.addToCartBackInStock(bodyData)
      .subscribe(
        data => {
          if (data.response) {
            if (data.status == 1169 || data.status == 1168) {
              this.productList = this.productList.filter(item => item.product_id !== product.product_id);
              this.totalProductCount = this.totalProductCount - 1
              this.statePersist.emitmobileListCountDetails('mobile count change')
              this.statePersist.emitoutOfStockData('change out Of stock data')
            }
            else if(data.status == 2212){
              this.alertService.error(data.response)
              for (let i = 0; i < this.productList.length; i++) {
                if (this.productList[i]['product_id'] == product.product_id) {
                  this.productList[i]['qty'] = '1'
                }
            }
            }
            else if(data.status == 1180){
              localStorage.setItem('closeStorInfoMessage', data.response.msg)
              document.getElementById("openclosedStoreInfo").click();
              for (let i = 0; i < this.productList.length; i++) {
                if (this.productList[i]['product_id'] == product.product_id) {
                  this.productList[i]['qty'] = '1'
                }
            }
            }
          else{
            this.productList = this.productList.filter(item => item.product_id !== product.product_id);
            this.totalProductCount = this.totalProductCount - 1
            this.statePersist.emitmobileListCountDetails('mobile count change')
            this.statePersist.emitmyCartData('change my cart data')
            this.statePersist.emitminiCartData('change mini cart')
            this.statePersist.emitOrderDetailData('updae order Deatil')
            
          }
 
          }

        }
      );  
  }

}
